/**
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ClrCommonPopoverModule } from "../common/popover.module";
import { TOOLTIP_DIRECTIVES } from "./index";
var ClrTooltipModule = (function () {
    function ClrTooltipModule() {
    }
    return ClrTooltipModule;
}());
export { ClrTooltipModule };
ClrTooltipModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule,
                    ClrCommonPopoverModule
                ],
                declarations: [
                    TOOLTIP_DIRECTIVES
                ],
                exports: [
                    TOOLTIP_DIRECTIVES
                ]
            },] },
];
/** @nocollapse */
ClrTooltipModule.ctorParameters = function () { return []; };
//# sourceMappingURL=tooltip.module.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/popover/tooltip/tooltip.module.js
// module id = 211
// module chunks = 4